import { render, staticRenderFns } from "./RegisterSetPassword.vue?vue&type=template&id=fdd18952&scoped=true&"
import script from "./RegisterSetPassword.vue?vue&type=script&lang=js&"
export * from "./RegisterSetPassword.vue?vue&type=script&lang=js&"
import style0 from "./RegisterSetPassword.vue?vue&type=style&index=0&id=fdd18952&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdd18952",
  null
  
)

export default component.exports